import { createAction } from '@reduxjs/toolkit'
import { PPProduct } from 'shared'

export const upgradeSuccess = createAction<{ newPlan: string, productInfo: PPProduct | undefined }>(
  'ACTION_UPGRADE_SUCCESS'
)
